import React from "react";
import { Link } from "react-router-dom";
import { FaToolbox, FaHandshake, FaArrowRight } from "react-icons/fa";
import { Reveal } from "../../../components/common";

const ITEMS = [
  {
    id: "tools",
    to: "/tools",
    icon: FaToolbox,
    eyebrow: "Free · No signup",
    title: "Our Tools",
    description: "Pen Path, Arvix Color and Measurix: free practice tools we built for the design community.",
    cta: "Explore tools",
  },
  {
    id: "collab",
    to: "/collab",
    icon: FaHandshake,
    eyebrow: "Branding + development",
    title: "Arvix Creative × CodeJBorg",
    description: "Logo & brand identity by Arvix Creative. Designed and built by CodeJBorg.",
    cta: "See the collab",
  },
];

const ExploreMoreSection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <Reveal key={item.id} delay={i * 110} className="h-full">
              <Link
                to={item.to}
                className="group relative flex h-full flex-col justify-between gap-8 overflow-hidden rounded-3xl bg-designer-dark p-7 md:p-9 transition-shadow duration-300 hover:shadow-[0_24px_60px_-24px_rgba(29,32,48,0.5)] focus:outline-none focus-visible:ring-2 focus-visible:ring-designer-primary focus-visible:ring-offset-2"
              >
                <div
                  className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-designer-primary/25 blur-[80px] transition-opacity duration-500 opacity-60 group-hover:opacity-100 pointer-events-none"
                  aria-hidden="true"
                />
                <div className="relative">
                  <div className="flex items-center justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-designer-accent text-xl">
                      <Icon />
                    </span>
                    <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40">
                      {item.eyebrow}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display font-bold text-white text-2xl md:text-[1.7rem] leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-white/60 leading-relaxed max-w-md">
                    {item.description}
                  </p>
                </div>
                <span className="relative inline-flex items-center gap-2 text-sm font-semibold text-white">
                  <span className="link-sweep">{item.cta}</span>
                  <FaArrowRight className="w-3.5 h-3.5 text-designer-primary transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" />
                </span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default ExploreMoreSection;
